import { Fragment } from 'react';
import { MessageCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useCancellationPlan } from 'src/context/billing';
import env from 'env';

import CallToActionBanner from './CallToActionBanner';
import GetOfferButton from './GetOfferButton';

const CancellationPrompt = () => {
  const {
    ui: { setStep },
  } = useCancellationPlan();

  const onContactUs = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  const onCancel = () => setStep('show-downgrade-confirmation');

  const onKeepPlan = () => setStep('keep-plan');

  return (
    <Fragment>
      <CallToActionBanner
        title="Exclusive offer: keep your plan for less"
        description="To show our appreciation for your business, we’re pleased to offer you an exclusive loyalty discount. You can continue to enjoy all the benefits and features you love—now at a reduced rate."
        variant="secondary"
        action={<GetOfferButton />}
      />
      <CallToActionBanner
        title="Cancel your plan"
        description="If you want to cancel your paid plan and no longer be charged, you can change your account to a free plan. Doing this will mean you lose access to your application continuity solutions."
        variant="secondary"
        action={
          <Button variant="secondary" onClick={onCancel}>
            Cancel plan
          </Button>
        }
      />
      <CallToActionBanner
        title="Is something wrong?"
        description="Before you go, give us a chance to make things right."
        action={
          <Button variant="outline" onClick={onContactUs}>
            <MessageCircle /> Contact us
          </Button>
        }
      />
      <div className="flex justify-end">
        <Button onClick={onKeepPlan}>Keep Plan</Button>
      </div>
    </Fragment>
  );
};

export default CancellationPrompt;
